// imports
import { allGenreLinks } from './nav-data';
import NavLink from './NavLink';

// lib files
// @TODO clean up this prop after launch
import { ExploreTopicLabelEnum, ExploreTopicRouteEnum } from "@/lib/constants";

// svgs
import PassportCompass from '/public/svg/compass-rose.svg';

// styles
import styles from './AllGenresMenu.module.scss';
import LinkButton from '../Button/LinkButton';
interface AllGenresMenuProps {
  className?: string;
  // @TODO clean up this prop after launch
  includeAmericaAt250?: boolean;
}
const AllGenresMenu = (props: AllGenresMenuProps) => {
  const {
    className,
    includeAmericaAt250
  } = props;
  let classes = styles.all_genres_menu;
  if (className) {
    classes += ` ${className}`;
  }

  // @TODO clean this up after launch - it won't be needed once the update to nav-data.ts is done
  if (includeAmericaAt250) {
    const featuredCivicsIndex = allGenreLinks.featured.findIndex(link => link.label === ExploreTopicLabelEnum.Civics);
    if (featuredCivicsIndex !== -1) {
      allGenreLinks.featured[featuredCivicsIndex] = {
        label: ExploreTopicLabelEnum.AmericaAt250,
        href: ExploreTopicRouteEnum.AmericaAt250
      };
    }
  }
  return <div className={classes} data-sentry-component="AllGenresMenu" data-sentry-source-file="AllGenresMenu.tsx">
      <h2>Genres</h2>
      <div className={styles.all_genres_menu__genres_wrapper}>
        <ul className={styles.all_genres_menu__left}>
          {allGenreLinks.genres.map(({
          label,
          href
        }, index) => {
          return <li key={index}>
                <NavLink href={href}>
                  {label}
                </NavLink>
              </li>;
        })}
        </ul>
        <ul className={styles.all_genres_menu__right}>
          {allGenreLinks.featured.map(({
          label,
          href,
          include_passport_icon
        }, index) => {
          return <li key={index}>
                {include_passport_icon && <PassportCompass className={styles.passport_compass} />}
                <NavLink href={href}>
                  {label}
                </NavLink>
              </li>;
        })}
        </ul>
      </div>
      <LinkButton href={"/shows/"} data-sentry-element="LinkButton" data-sentry-source-file="AllGenresMenu.tsx">
        All Shows
      </LinkButton>
    </div>;
};
export default AllGenresMenu;